import { render, staticRenderFns } from "./IpoPublicOffering.vue?vue&type=template&id=2df38441"
import script from "./IpoPublicOffering.vue?vue&type=script&lang=js"
export * from "./IpoPublicOffering.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports